import { gql } from 'graphql-request'

export const REMOVE_BOOKMARK_BY_CHAPTER_ID = gql`
  mutation RemoveBookmarkByBookChapterId($bookChapterId: Int!) {
    removeBookmarkByBookChapterId(bookChapterId: $bookChapterId) {
      id
    }
  }
`
